import { useGlobalData } from 'core/store';

function useCurrentUser() {
  return useGlobalData('user');
}

export { useCurrentUser };
